import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Box, Container, useMediaQuery, } from "@mui/material"
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import usLocale from "date-fns/locale/en-US"
import { ThemeProvider, StyledEngineProvider, useTheme } from "@mui/material/styles"
import { theme } from "./ui/theme"
import "@fontsource/roboto"
import CssBaseline from "@mui/material/CssBaseline"
import "./css/App.css"
import PrivateRoute from "./components/PrivateRoute"
import Login from "./pages/Login"
import PasswordForgot from "./pages/PasswordForgot"
import PublicRoute from "./components/PublicRoute"
import Home from './pages/Home'
import NewUser from "./pages/NewUser"
import Menu from "./pages/Menu"
import Cart from "./pages/Cart"
import ProductDetails from "./pages/ProductDetails"
import Checkout from "./pages/Checkout"
import NotFound from "./pages/NotFound"
import Unauthorized from "./pages/Unauthorized"
import Footer from "./components/Footer"
import NavBar from "./components/NavBar"
import Notifications from "./components/Notifications"
import Spinner from "./components/Spinner"
import AccountRegister from "./pages/AccountRegister"
import Carrousel from "./components/Carrousel"
import { Contenedor } from "./ui/Contenedor"
import { CustomerSeller } from "./pages/CustomersSeller"



const App = () => {
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={usLocale}>
          <CssBaseline />
          <Spinner />
          <Router basename="/">
            {!mobile && <Box display="flex" justifyContent="center" width="100%">
              <Carrousel />
            </Box>}
            <Container>
              <NavBar />
              <Notifications />
            </Container>
            <Routes>
              <Route element={<PrivateRoute validRoles={["Cliente", "Administrador"]} />}>
                <Route path={"/"} element={<Contenedor children={<Home />} isBox={true} isBreadCrumb={true} />} />
                <Route path={"/cart"} element={<Contenedor children={<Cart />} />} />
                <Route path={"/checkout"} element={<Contenedor children={<Checkout />} />} />
                <Route path={"/product-details/:productId"} element={<Contenedor children={<ProductDetails />} isBreadCrumb={true} isProductDetails={true} />} />
              </Route>
              <Route element={<PrivateRoute validRoles={["Administrador", "Cliente", "Vendedor", "Admin Ventas"]} />}>
                <Route exact path={"/menu"} element={<Contenedor children={<Menu />} />} />
              </Route>
              <Route element={<PrivateRoute validRoles={["Vendedor", "Admin Ventas",]} />}>
                <Route path={"/lista-clientes"} element={<Contenedor children={<CustomerSeller />} />} />
              </Route>
              <Route element={<PublicRoute restricted={true} />}>
                <Route path="/login" element={<Contenedor children={<Login />} />} />
                {/* <Route path="/newUser" element={<Contenedor children={<NewUser />} />} /> */}
                <Route path="/resetpassword" element={<Contenedor children={<PasswordForgot />} />} />
                {/* <Route path="/register" element={<Contenedor children={<AccountRegister />} />} /> */}
              </Route>
              <Route element={<PublicRoute />}>
                <Route path="/unauthorized" element={<Contenedor isVendedor={true} children={<Unauthorized />} />} />
                <Route path="*" element={<Contenedor children={<NotFound />} />} />
              </Route>
            </Routes>
            <div className="filler" />
            <Container>
              <Footer />
            </Container>
          </Router>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App